// src/state/merchantInsightsStore.js

const API_BASE =
  "https://veya-backend-xixx.onrender.com";

const USE_MOCK = true; // ← flip to false later

const MOCK_PAYLOAD = {
  generated_at: new Date().toISOString(),
  window_days: 30,
  merchant_id: "demo",

  totals: {
    windowEdits: 14,
    windowTryOns: 82,
    windowPins: 37,
    windowBags: 21,
    catalogProducts: 24,
    signalBase: 67,
  },

  market_trends: {
    headline: "Structured layering and tonal neutrals are consolidating, with stronger purchase intent gathering around polished separates.",
dominantLooks: [
  {
    name: "Soft tailoring",
    summary: "Relaxed blazers with fluid trousers and polished grounding pieces.",
    supportScore: 18,
    heroImage: "/veya_edits/soft%20power/softpower1.png",
    keyPieces: [
      "Relaxed blazer",
      "Fluid trousers",
      "Linen shirt",
      "Clean tank",
      "Neutral palette",
    ],
    examplePieces: [
      "block coloured blazer",
      "oversized trousers",
      "linen button down",
      "relaxed blazer",
      "clean tank",
    ],
    referenceProducts: [
      {
        id: "ref_1",
        image: "/veya_edits/soft%20power/softpower1.png",
      },
      {
        id: "ref_2",
        image: "/veya_edits/soft%20power/softpower2.png",
      },
      {
        id: "ref_3",
        image: "/veya_edits/soft%20power/softpower3.png",
      },
    ],
  },
  {
    name: "Monochrome minimal",
    summary: "Single-tone outfits with texture contrast and cleaner column dressing.",
    supportScore: 12,
    heroImage: "/veya_edits/tonal%20layers/tonallayers1.png",
    keyPieces: [
      "Tonal palette",
      "Ribbed knit",
      "Column silhouette",
      "Layering",
      "Minimal styling",
    ],
    examplePieces: [
      "tonal dressing",
      "ribbed knits",
      "clean lines",
      "minimal accessories",
      "tonal layering",
    ],
    referenceProducts: [
      {
        id: "ref_4",
        image: "/veya_edits/tonal%20layers/tonallayers1.png",
      },
      {
        id: "ref_5",
        image: "/veya_edits/tonal%20layers/tonallayers2.png",
      },
      {
        id: "ref_6",
        image: "/veya_edits/tonal%20layers/tonallayers3.png",
      },
    ],
  },
],
    palettes: [
      { label: "Warm neutrals", shades: ["beige", "tan", "cream"] },
      { label: "Muted contrast", shades: ["charcoal", "soft black"] },
      { label: "Soft blues", shades: ["powder blue", "denim", "navy"] },
    ],
    keySignals: ["tailored", "relaxed fit", "layering", "polished", "minimal"],
  },

  catalog_vs_demand: [
    {
      label: "Relaxed trousers",
      note: "High engagement but limited depth in catalog",
      interestPct: 72,
      coveragePct: 38,
    },
    {
      label: "Structured blazers",
      note: "Strong alignment between demand and stock",
      interestPct: 64,
      coveragePct: 68,
    },
    {
      label: "Soft blue shirting",
      note: "Building interest with lighter current coverage",
      interestPct: 41,
      coveragePct: 22,
    },
  ],

  catalog_product_insights: [
    {
      product_id: "p_101",
      title: "Relaxed Pleat Trouser",
      image: "https://images.unsplash.com/photo-1506629905607-d9d8c8e93979?auto=format&fit=crop&w=600&q=80",
      category: "bottom",
      try_ons: 19,
      saves: 11,
      edits: 9,
      bags: 7,
      demand_score: 103,
      top_pairings: [
        { product_id: "p_201", title: "Soft Tailored Blazer", count: 6 },
        { product_id: "p_301", title: "Rib Column Knit", count: 4 },
      ],
    },
    {
      product_id: "p_201",
      title: "Soft Tailored Blazer",
      image: "https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?auto=format&fit=crop&w=600&q=80",
      category: "outer",
      try_ons: 16,
      saves: 13,
      edits: 8,
      bags: 6,
      demand_score: 97,
      top_pairings: [
        { product_id: "p_101", title: "Relaxed Pleat Trouser", count: 6 },
        { product_id: "p_401", title: "Minimal Scoop Tank", count: 3 },
      ],
    },
    {
      product_id: "p_301",
      title: "Rib Column Knit",
      image: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&w=600&q=80",
      category: "top",
      try_ons: 14,
      saves: 9,
      edits: 7,
      bags: 4,
      demand_score: 73,
      top_pairings: [
        { product_id: "p_101", title: "Relaxed Pleat Trouser", count: 4 },
        { product_id: "p_501", title: "Longline Wool Coat", count: 2 },
      ],
    },
    {
      product_id: "p_401",
      title: "Minimal Scoop Tank",
      image: "https://images.unsplash.com/photo-1485968579580-b6d095142e6e?auto=format&fit=crop&w=600&q=80",
      category: "top",
      try_ons: 11,
      saves: 8,
      edits: 5,
      bags: 3,
      demand_score: 56,
      top_pairings: [
        { product_id: "p_201", title: "Soft Tailored Blazer", count: 3 },
        { product_id: "p_101", title: "Relaxed Pleat Trouser", count: 3 },
      ],
    },
    {
      product_id: "p_501",
      title: "Longline Wool Coat",
      image: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=600&q=80",
      category: "outer",
      try_ons: 8,
      saves: 6,
      edits: 3,
      bags: 1,
      demand_score: 35,
      top_pairings: [
        { product_id: "p_301", title: "Rib Column Knit", count: 2 },
      ],
    },
    {
      product_id: "p_601",
      title: "Powder Blue Shirt",
      image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?auto=format&fit=crop&w=600&q=80",
      category: "top",
      try_ons: 5,
      saves: 4,
      edits: 2,
      bags: 0,
      demand_score: 18,
      top_pairings: [
        { product_id: "p_101", title: "Relaxed Pleat Trouser", count: 2 },
      ],
    },
  ],

  strategy_signals: [
    {
      title: "Lean into soft tailoring",
      body: "Customers are consistently combining relaxed structure with fluid silhouettes. Expanding here would deepen alignment.",
    },
    {
      title: "Protect high-intent winners",
      body: "Bag activity is clustering around tailored separates, suggesting stronger purchase intent than saves alone. These pieces are worth prioritising in replenishment and merchandising.",
    },
    {
      title: "Maintain tonal identity",
      body: "Your current palette aligns well. You can reinforce rather than diversify aggressively.",
    },
  ],
};

export async function getMerchantInsights30d() {
  if (USE_MOCK) {
    await new Promise((r) => setTimeout(r, 300)); // simulate load
    return MOCK_PAYLOAD;
  }

  const token = localStorage.getItem("veya_token");

  const res = await fetch(`${API_BASE}/merchant/insights/market`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(
      `Failed to load merchant insights (${res.status})${text ? `: ${text}` : ""}`
    );
  }

  return res.json();
}